import { TaxTableEntityType } from '@reliance/types/enums/TaxTableEntityType';
import { Facility } from '@reliance/types/models/Facility';
import { FORM_ERROR } from 'final-form';
import React from 'react';
import Button from 'react-bootstrap/Button';
import Card from 'react-bootstrap/Card';
import Col from 'react-bootstrap/Col';
import Row from 'react-bootstrap/Row';
import { Form } from 'react-final-form';
import { alertStore } from '../alert/alertStore';
import api from '../common/api';
import { Select } from '../form/Select';
import { formatTaxTableDescription } from '../format/TaxTableDescription';
import { useTaxTables } from '../hooks/Tax';

type EditTaxesProps = {
  facility: Facility;
  onSave(): any;
};

const EditTaxes: React.FC<EditTaxesProps> = (props) => {
  const taxTables = useTaxTables();
  const sortedTaxTables = (taxTables.result || []).sort((a,b) => a.entityName.localeCompare(b.entityName));
  const cityTaxes = sortedTaxTables.filter((t) => t.entityType == TaxTableEntityType.CITY);
  const stateTaxes = sortedTaxTables.filter((t) => t.entityType == TaxTableEntityType.STATE);
  const fedTaxes = sortedTaxTables.filter((t) => t.entityType == TaxTableEntityType.FED);
  const fusfTaxes = sortedTaxTables.filter((t) => t.entityType == TaxTableEntityType.FUSF);
  const trsTaxes = sortedTaxTables.filter((t) => t.entityType == TaxTableEntityType.TRS);
  const fssfTaxes = sortedTaxTables.filter((t) => t.entityType == TaxTableEntityType.FSSF);

  const initialValues = {
    cityTaxId: props.facility.cityTax?.id,
    stateTaxId: props.facility.stateTax?.id,
    fedTaxId: props.facility.fedTax?.id,
    usfTaxId: props.facility.usfTax?.id,
    trsTaxId: props.facility.trsTax?.id,
    fssfTaxId: props.facility.fssfTax?.id,
  };

  return (
    <Form
      initialValues={initialValues}
      onSubmit={(formData) =>
        api.put(`/facility/${props.facility.id}`, formData)
          .then(() => alertStore.success('Facility was successfully saved'))
          .then(() => localStorage.removeItem('cachedFacilities'))
          .then(props.onSave)
          .catch((err) => ({ [FORM_ERROR]: err }))
      }
      render={(form) =>
        <form onSubmit={form.handleSubmit}>
          <Card>
            <Card.Body>
              <Row>
                <Col>
                  <Select
                    name="cityTaxId"
                    label="City Tax">
                    <option></option>
                    {cityTaxes.map((t) =>
                      <option key={`city-tax-${t.id}`} value={t.id}>{formatTaxTableDescription(t)}</option>
                    )}
                  </Select>
                  <Select
                    name="stateTaxId"
                    label="State Tax">
                    <option></option>
                    {stateTaxes.map((t) =>
                      <option key={`state-tax-${t.id}`} value={t.id}>{formatTaxTableDescription(t)}</option>
                    )}
                  </Select>
                  <Select
                    name="fedTaxId"
                    label="Federal Tax">
                    <option></option>
                    {fedTaxes.map((t) =>
                      <option key={`fed-tax-${t.id}`} value={t.id}>{formatTaxTableDescription(t)}</option>
                    )}
                  </Select>
                </Col>

                <Col>
                  <Select
                    name="usfTaxId"
                    label="FUSF Tax">
                    <option></option>
                    {fusfTaxes.map((t) =>
                      <option key={`usf-tax-${t.id}`} value={t.id}>{formatTaxTableDescription(t)}</option>
                    )}
                  </Select>
                  <Select
                    name="trsTaxId"
                    label="TRS Charge">
                    <option></option>
                    {trsTaxes.map((t) =>
                      <option key={`trs-tax-${t.id}`} value={t.id}>{formatTaxTableDescription(t)}</option>
                    )}
                  </Select>
                  <Select
                    name="fssfTaxId"
                    label="FCC Rate Additive">
                    <option></option>
                    {fssfTaxes.map((t) =>
                      <option key={`fssf-tax-${t.id}`} value={t.id}>{formatTaxTableDescription(t)}</option>
                    )}
                  </Select>
                </Col>
              </Row>
            </Card.Body>
            <Card.Footer>
              <Button
                variant="primary"
                disabled={form.submitting || form.hasValidationErrors}
                type="submit">
                Save
              </Button>
            </Card.Footer>
          </Card>
        </form>
      } />
  );
};

export default EditTaxes;
